<template>
  <div class="whole-calendar-card">
    <div v-if="squareCardActive" class="whole-calendar-card__card-list">
      <slot name="eventCard" />
    </div>
    <div class="calendar-wrap">
      <slot name="calendar" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'WholeCalendarCard',
  props: {
    squareCardActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/whole-calendar-card';
</style>
